import { render, staticRenderFns } from "./medicalScienceDetail.vue?vue&type=template&id=8360c7a4&scoped=true"
import script from "./medicalScienceDetail.vue?vue&type=script&lang=js"
export * from "./medicalScienceDetail.vue?vue&type=script&lang=js"
import style0 from "../../assets/css/articleDetail.css?vue&type=style&index=0&id=8360c7a4&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8360c7a4",
  null
  
)

export default component.exports